export default function() {
  return new Worker(__webpack_public_path__ + "static/js/worker.bcca9395.worker.js");
}
